// SPDX-License-Identifier: LicenseRef-Pachamama-Proprietary
// Copyright 2026 Pachamama Studios B.V. All rights reserved.

/**
 * AYNI — closes whichever chat panel the page mounted: the AYNI chatbot's
 * or, until it is swapped out, the old one. Panels that take the chat's
 * place (the info panel expanding, the Help panel opening) call
 * `closeActiveChat`; `main.ts` says which panel that is (`setChatCloser`).
 */

let closer: () => void = () => {}

/** Called by `main.ts` once it knows which chat panel this page runs. */
export function setChatCloser(close: () => void): void {
  closer = close
}

export function closeActiveChat(): void {
  closer()
}
